import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { globalStyle, style, styleVariants } from '@vanilla-extract/css';

export const statsContainer = style([
  typography.labelMd,
  {
    display: 'flex',
    gap: space.s4,
    color: themeVars.container.foreground.secondary,
  },
]);
export const statItem = style({
  display: 'flex',
  gap: space.s4,
  alignItems: 'center',
  textTransform: 'capitalize',
});
globalStyle(`.${statItem} :where(svg)`, {
  height: 16,
  width: 16,
  minWidth: 16,
});

export const statStateGroup = styleVariants({
  active: [
    statItem,
    {
      color: themeVars.container.foreground.success,
    },
  ],
  closed: [
    statItem,
    {
      color: themeVars.container.foreground.warning,
    },
  ],
  ended: [
    statItem,
    {
      color: themeVars.container.foreground.primary,
    },
  ],
});

export const statSeparator = style({});
